export default __webpack_public_path__ + "static/media/logo.a62a9f24.png";